/** Lingue caricate in i18n (allineare a `index.js` e `lingui.config.js`). */
export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'ru', 'tg']
